<template>
	<div class="add-item-quantity-wrapper">
		<div class="add-item-quantity-label">Quantity</div>
		<div class="add-item-quantity">
			<button
				class="item-quantity-button"
				:aria-label="`Decrease Quantity for ${itemName} from ${quantity} to ${quantity - 1}`"
				type="button"
				@click="handleQuantityDecrease()"
			>
				-
			</button>
			<span class="item-quantity" tabindex="0" :aria-label="`Quantity ${quantity}`">{{ quantity }}</span>
			<button
				class="item-quantity-button"
				:aria-label="`Increase Quantity for ${itemName} from ${quantity} to ${quantity + 1}`"
				type="button"
				@click="handleQuantityIncrease()"
			>
				+
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "AddItemQuantity",
	props: {
		initQuantity: {
			default: 1,
			type: Number,
		},
		itemName: {
			type: String,
			default: "Item",
		},
	},
	data() {
		return {
			quantity: this.initQuantity ? this.initQuantity : 1,
		};
	},
	methods: {
		handleQuantityIncrease() {
			this.quantity++;
			this.$emit("input", this.quantity);
		},
		handleQuantityDecrease() {
			if (this.quantity > 1) {
				this.quantity--;
				this.$emit("input", this.quantity);
			}
			return false;
		},
	},
};
</script>

<style lang="scss" scoped>
.add-item-quantity-wrapper {
	margin: 0px 20px;
	width: 33%;
	display: flex;
	flex-direction: column;
}

.add-item-quantity {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.add-item-quantity-label {
	font-size: 18px;
	font-weight: 700;
	display: flex;
	justify-content: center;
}

.item-quantity-button {
	color: $white;
	background-color: $tomato;
	border-radius: 50%;
	display: flex;
	height: 30px;
	width: 30px;
	justify-content: center;
	font-weight: 700;
	font-size: 18.33px;

	&:hover,
	&:focus {
		background-color: $royal;
	}
}

.item-quantity {
	width: 48px;
	height: 27px;
	text-align: center;
	margin: 0 5px;
	font-size: 2rem;
	font-weight: 700;
}
</style>
